"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var get = exports.get = function get(item) {
    try {
        var serializedState = localStorage.getItem(item);

        if (serializedState === null) {
            return {};
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return {};
    }
};

var set = exports.set = function set(item, state) {
    try {
        var serializedState = JSON.stringify(state);
        localStorage.setItem(item, serializedState);
    } catch (err) {
        console.error(err);
    }
};
//# sourceMappingURL=store.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/feedback/lib/cjs/util/store.js
 ** module id = 728
 ** module chunks = 1
 **/